import { DEFAULT_INVOICE_LANGUAGE } from '../constants/defaultInvoiceLanguage'
import { invoiceLanguageToLocale } from '../constants/invoiceLanguageToLocale'
import { selectableInvoiceLanguages } from '../constants/selectableInvoiceLanguages'
import { isInvoiceLanguage } from './isInvoiceLanguage'

// Maps an invoicing-language setting (e.g. "fr") to its locale. Returns undefined when none
// is configured so each caller can apply its own fallback.
export const getDefaultInvoiceLocale = (settingsLanguage?: string) => {
  if (!isInvoiceLanguage(settingsLanguage)) {
    return undefined
  }

  const locale = invoiceLanguageToLocale[settingsLanguage]

  return selectableInvoiceLanguages.includes(locale) ? locale : invoiceLanguageToLocale[DEFAULT_INVOICE_LANGUAGE]
}
